module.exports = __webpack_public_path__ + "html/dialog.template.html";